var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"separator-bottom pt-3 pb-4"},[_c('Select_Horizontal',{staticClass:"font-weight-normal",attrs:{"options":_vm.options,"selected":_vm.currentCategory},on:{"select":_vm.selectCategory}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }